import { memoizeFunction } from '@agilepoint/utils-common';
import { css, DefaultTheme } from 'styled-components';
import { ButtonVariants, ButtonStates } from './theme';

export const buttonStyleGenerator = memoizeFunction((variant: ButtonVariants) => {
    const getThemeVariables = (theme: DefaultTheme, state: ButtonStates) => theme.button.colors[variant][state];
    return css`
        color: ${({ theme }) => getThemeVariables(theme, 'default').text};
        border-color: ${({ theme }) => getThemeVariables(theme, 'default').border};
        background-color: ${({ theme }) => getThemeVariables(theme, 'default').background};
        box-shadow: ${({ theme }) => getThemeVariables(theme, 'default').boxShadow};

        .ap-icon {
            fill: ${({ theme }) => getThemeVariables(theme, 'default').text};
        }
        
        &:hover:enabled {
            color: ${({ theme }) => getThemeVariables(theme, 'hovered').text};
            border-color: ${({ theme }) => getThemeVariables(theme, 'hovered').border};
            background-color: ${({ theme }) => getThemeVariables(theme, 'hovered').background};
            box-shadow: ${({ theme }) => getThemeVariables(theme, 'hovered').boxShadow};

            .ap-icon {
                fill: ${({ theme }) => getThemeVariables(theme, 'hovered').text};
            }
        }
        &:focus {
            outline-color: ${({ theme: { semantics: { palette } } }) => palette.themePrimary};
            color: ${({ theme }) => getThemeVariables(theme, 'focussed').text};
            border-color: ${({ theme }) => getThemeVariables(theme, 'focussed').border};
            background-color: ${({ theme }) => getThemeVariables(theme, 'focussed').background};
            box-shadow: ${({ theme }) => getThemeVariables(theme, 'focussed').boxShadow};

            .ap-icon {
                fill: ${({ theme }) => getThemeVariables(theme, 'focussed').text};
            }
        }
        &:disabled {
            cursor: not-allowed;
            color: ${({ theme }) => getThemeVariables(theme, 'disabled').text};
            border-color: ${({ theme }) => getThemeVariables(theme, 'disabled').border};
            background-color: ${({ theme }) => getThemeVariables(theme, 'disabled').background};
            box-shadow: ${({ theme }) => getThemeVariables(theme, 'disabled').boxShadow};

            .ap-icon {
                fill: ${({ theme }) => getThemeVariables(theme, 'disabled').text};
            }
        }
        &:active:focus, &:active:enabled {
            color: ${({ theme }) => getThemeVariables(theme, 'active').text};
            border-color: ${({ theme }) => getThemeVariables(theme, 'active').border};
            background-color: ${({ theme }) => getThemeVariables(theme, 'active').background};
            box-shadow: ${({ theme }) => getThemeVariables(theme, 'active').boxShadow};

            .ap-icon {
                fill: ${({ theme }) => getThemeVariables(theme, 'active').text};
            }
        }
    `;
});
